export default __webpack_public_path__ + "static/media/Sun_mobile.60e7cdaa.svg";